import { observer } from "mobx-react";
import * as React from "react";
import { applicationStore } from "../../../stores/ApplicationStore";
import { THEME } from "../../../theme/ThemeStore";
import { ApplicationValues } from "../../../types/models";
import { pushRoute } from "../../app/router/history";
import { ContentWrapper } from "../../ui/ContentWrapper";
import { TopImage } from "../../ui/TopImage";
import { DataUploadForm } from "../DataUploadForm";
import { ApplicationRoutes } from "../router/ApplicationRoutes";

export const DataUploadSite = observer(() => {
    React.useEffect(() => {
        if (!applicationStore.isStepFinished["details"]) {
            pushRoute(ApplicationRoutes.PERSONAL_DATA);
        }
    }, []);

    const handleSubmit = (model: ApplicationValues) => {
        applicationStore.currentApplication = model;
        applicationStore.isStepFinished["dataUpload"] = true;
        pushRoute(ApplicationRoutes.MOTIVATION);
    };

    const handleBack = () => {
        if (!applicationStore.canNavigate) {
            const currentStepIndex = Object.keys(applicationStore.isStepFinished).indexOf("dataUpload");
            applicationStore.setCurrentAndNextStepsToUnfinished(currentStepIndex);
        }
        pushRoute(ApplicationRoutes.DETAILS);
    };

    return (
        <>
            <TopImage imageUrl={THEME.Images.headerImage03} />
            <ContentWrapper>
                <DataUploadForm onSubmit={handleSubmit} onBack={handleBack} />
            </ContentWrapper>
        </>
    );
});
